export const CHECKOUT_URL = "https://biomagnetism-en.impultienda.ar/checkout/";

export const PRODUCT_IMAGE = "https://cdn.magicpatterns.com/uploads/h8ZiFCKZFCjzHhBoTwHVmh/BIOMAGNETISM-EN.png";
export const AUTHOR_IMAGE = "https://cdn.magicpatterns.com/uploads/pqBkc6SRi1zAJbPgkbNpqa/HELENA_DUARTE_-_APOMETRIA.png";

export const insideStats = [
  { value: "6", label: "Premium Digital Volumes" },
  { value: "30", label: "Days — A Structured Learning Roadmap" },
  { value: "5", label: "Exclusive Bonus Collections" },
  { value: "30+", label: "Ready-to-Use Resources, Templates & Checklists" },
];

export const beforeItems = [
  "You collect information without having a clear system for organizing it.",
  "You spend too much time searching through notes and documents.",
  "You aren't sure which concepts to review first.",
  "You create your own study sheets every time you need them.",
  "You struggle to maintain a consistent learning routine.",
  "You finish a study session without clearly documenting what you've learned.",
];

export const afterItems = [
  "You follow a structured learning pathway.",
  "You use ready-made templates to organize your notes.",
  "You navigate concepts through visual maps and reference sheets.",
  "You have checklists to guide your study activities.",
  "You follow a 30-day learning roadmap.",
  "You document your progress using prepared worksheets.",
];

export const painPoints = [
  {
    icon: "books",
    title: "You have too much information and no clear structure.",
    text: "You've watched lessons, downloaded documents, and saved articles, but everything is scattered across different files and notebooks.",
  },
  {
    icon: "timer",
    title: "You spend more time organizing than studying.",
    text: "Every time you want to review a topic, you need to search through your materials, create new notes, or rebuild your study plan.",
  },
  {
    icon: "question",
    title: "You don't know what to review next.",
    text: "You want a clear sequence that helps you organize your learning activities instead of deciding everything from scratch.",
  },
  {
    icon: "notes",
    title: "You keep creating the same study materials.",
    text: "You need concept sheets, review cards, checklists, and reference templates—but you don't want to spend hours designing them yourself.",
  },
  {
    icon: "repeat",
    title: "You struggle to maintain consistency.",
    text: "You start studying with enthusiasm, but without a structured plan, your routine becomes difficult to maintain.",
  },
  {
    icon: "sprout",
    title: "You want a practical way to organize your biomagnetism learning journey.",
    text: "You don't necessarily need another lengthy video course. You want educational tools that help you put your studies into a clear, repeatable structure.",
  },
];

export const tools = [
  { icon: "notes", title: "Ready-to-Use Study Templates", text: "Preformatted worksheets for organizing notes, recording concepts, and documenting questions." },
  { icon: "checklist", title: "Educational Checklists", text: "Structured lists to guide your study sessions, review activities, and personal organization." },
  { icon: "map", title: "Visual Concept Maps", text: "Visual resources that help you organize introductory topics and relationships between concepts." },
  { icon: "chart", title: "Progress Tracking Sheets", text: "Prepared worksheets for monitoring your learning activities and reviewing your progress." },
  { icon: "calendar", title: "A 30-Day Study Planner", text: "A structured roadmap that helps you plan your study sessions and keep your learning activities organized." },
];

export const purposes = [
  { icon: "books", title: "Organize Your Educational Materials", text: "Use the ready-made templates and reference sheets to create a more consistent structure for your studies." },
  { icon: "map", title: "Navigate Introductory Concepts", text: "Use visual maps and organized summaries to navigate the material you're studying." },
  { icon: "checklist", title: "Follow Prepared Study Procedures", text: "Use the educational checklists to structure activities such as reviewing concepts, documenting questions, and organizing reference materials." },
  { icon: "calendar", title: "Maintain a Learning Routine", text: "Follow the 30-day roadmap and use the planning sheets to structure your study sessions." },
  { icon: "notes", title: "Track Your Progress", text: "Use the progress sheets and review templates to document what you've studied and identify what you want to revisit." },
  { icon: "repeat", title: "Continue Using the System", text: "Keep the templates and reference materials available as you continue exploring the subject." },
];

export const testimonials = [
  {
    name: "Laura M.",
    location: "Austin, Texas",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/0e73d2ce-df0d-4314-aae8-0b30dd2054c1.jpg",
    quote:
      "I had notes in three notebooks and a dozen PDFs. The Foundation volume and the topic index finally gave me one place to put everything. My study sessions feel calm instead of chaotic.",
  },
  {
    name: "Richard T.",
    location: "Manchester, UK",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/bfd36346-4c23-47e6-912f-e633481e8bc9.jpg",
    quote:
      "The 30-day roadmap is what sold me. I open the day's sheet, follow the checklist, and log what I covered. No more deciding what to do every evening.",
  },
  {
    name: "Andrea P.",
    location: "Toronto, Canada",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/e84543b3-4aa1-4b2d-9396-8de81dd18c8a.jpg",
    quote:
      "The concept map templates and review cards saved me hours of formatting. I print them, fill them in, and actually review instead of rebuilding materials.",
  },
];

export const faqs = [
  { q: "How will I receive the materials?", a: "After your payment is confirmed, you'll receive instructions for accessing your digital collection. The six volumes and five bonuses will be provided in the downloadable formats specified on the checkout page." },
  { q: "Is this product suitable for beginners?", a: "Yes. The collection is designed to help beginners and existing students organize their introductory studies and learning materials. It is an educational organization system, not a replacement for comprehensive professional training." },
  { q: "Do I need previous experience with biomagnetism?", a: "No previous experience is required to use the introductory organizational tools. You can start with the foundational volume and follow the learning roadmap at your own pace." },
  { q: "Is this a video course?", a: "No. The Biomagnetism Protocol Vault is a digital collection of educational resources, structured learning pathways, templates, checklists, visual references, and planning tools. It is designed for people who want a ready-made way to organize their studies." },
  { q: "Does the product teach clinical diagnosis or treatment?", a: "The Protocol Vault is an educational organization resource. It does not provide validated diagnostic procedures, establish clinical competence, or demonstrate that biomagnetism can diagnose or treat diseases. Its learning protocols guide educational activities such as organizing information, reviewing concepts, and documenting study progress. It should not be used to make medical decisions or replace evidence-based medical care." },
  { q: "Will I receive a professional certificate?", a: "No. This product does not provide a professional qualification, clinical certification, or license to practice healthcare." },
  { q: "Can I download the files?", a: "Yes. The product is designed to be delivered as downloadable digital resources. The checkout page will specify the available formats and access instructions." },
  { q: "Is this a one-time payment?", a: "Yes. The price is $27 USD as a one-time payment. There is no recurring subscription for the collection." },
  { q: "Will I have lifetime access?", a: "The offer includes lifetime access to the purchased digital materials, subject to the applicable purchase terms and delivery conditions." },
  { q: "What if the product isn't right for me?", a: "Your purchase includes a 7-day money-back guarantee. If you decide the collection isn't suitable for your needs, you can request a refund within the guarantee period according to the purchase terms." },
  { q: "Can I use the Protocol Vault alongside another course?", a: "Yes. The collection is designed to complement other educational materials by helping you organize notes, review concepts, and track your learning activities. Always respect the applicable copyright and usage terms for any materials you use." },
  { q: "Does the 30-day roadmap guarantee that I'll master biomagnetism in 30 days?", a: "No. The roadmap is designed to help you organize your learning activities over 30 days. Individual progress depends on your background, study habits, and the material you're learning. The product does not guarantee mastery, professional competence, or clinical outcomes." },
  { q: "Is the product delivered immediately?", a: "Digital access is provided after payment confirmation, subject to the delivery process described at checkout." },
];

export const recentBuyers = [
  { name: "María González", country: "Mexico" },
  { name: "Carlos Rodríguez", country: "Colombia" },
  { name: "Lucía Fernández", country: "Spain" },
  { name: "Javier Morales", country: "Argentina" },
  { name: "Valentina Rojas", country: "Chile" },
  { name: "Andrés Castillo", country: "Peru" },
  { name: "Camila Herrera", country: "Ecuador" },
  { name: "Diego Ramírez", country: "Venezuela" },
  { name: "Sofía Martínez", country: "Uruguay" },
  { name: "Gabriela Torres", country: "Costa Rica" },
  { name: "Fernando López", country: "Guatemala" },
  { name: "Isabel Cruz", country: "Dominican Republic" },
  { name: "Mariana Vargas", country: "Bolivia" },
  { name: "Ricardo Méndez", country: "Paraguay" },
  { name: "Daniela Ortiz", country: "Puerto Rico" },
  { name: "Alejandro Ruiz", country: "Panama" },
];
